export default __webpack_public_path__ + "/dist/images/4196114.1da6dfa5c44d4fcc80683de278d505de.png";